import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'

export default class CVPlanetCardEntry extends Component {

	render() {
		let planetCardEntryImage = ``;
		if("icon" in this.props && typeof this.props.icon !== "undefined")
		{
			planetCardEntryImage = `/gfx/${this.props.icon}`;
		}
		let entryStyle = {
			transform: `perspective(1px) translateY(${this.props.offsetY}px)`
		};

		return (
			<div className="layout-cs-card-entry" data-tip data-for={this.props.tooltipId} onClick={() => { this.props.onClick(this.props.id) }} style={entryStyle}>
				{planetCardEntryImage.length > 0 ? <img className="layout-cs-card-display" src={planetCardEntryImage} alt={this.props.title} /> : <span className="layout-cs-card-display">{this.props.title}</span>}
				<ReactTooltip id={this.props.tooltipId} place="top" type="dark" effect="solid">
					{this.props.title}
				</ReactTooltip>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/CVPlanetCardEntry.js